import axios from 'axios'

const apiUrl = window.config.apiUrl

export const getRFIInfantMeatsPackage = newProduct => {
  let newRFIInfantMeatsPackage = {
    UPC: newProduct.UPC,
    PackageType: newProduct.PackageType,
    Size: newProduct.Size,
    NoAdditionalIngredients: newProduct.NoAdditionalIngredients,
    Organic: newProduct.Organic,
    MultiPackageType: newProduct.MultiPackageType,
  }
  if (newProduct.MultiPackageType === true) {
    newRFIInfantMeatsPackage.MultiPackageCount = newProduct.MultiPackageCount
  }
  return newRFIInfantMeatsPackage
}
export const updateRFIInfantMeatsPackage = newProduct => {
  let newRFIInfantMeatsPackage = {
    UPC: newProduct.UPC,
    PackageType: newProduct.PackageType,
    Size: newProduct.Size,
    NoAdditionalIngredients: newProduct.NoAdditionalIngredients,
    Organic: newProduct.Organic,
    MultiPackageType: newProduct.MultiPackageType,
  }
  if (newProduct.MultiPackageType === true) {
    newRFIInfantMeatsPackage.MultiPackageCount = newProduct.MultiPackageCount
  }
  return newRFIInfantMeatsPackage
}

export const getRFIInfantMeatsCategories = async () => {
  try {
    const brandNameOptions = []
    const userToken = JSON.parse(localStorage.getItem('okta-token-storage'))

    await axios
      .get(`${apiUrl}/products/brandspecific/rfi/infant/meats/categories`, {
        headers: {
          Authorization: `Bearer ${userToken?.accessToken?.accessToken}`,
        },
      })
      .then(res => {
        JSON.parse(res.data.result).forEach(brandName => {
          brandNameOptions.push({
            value: brandName,
            label: brandName,
          })
        })
      })
    return brandNameOptions
  } catch (err) {
    console.log('getRFIInfantMeatsCategories error: ', err.response?.msg)
  }
}
